"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Problem } from "./problem";
import { Solution } from "./solution";
import { CapabilitiesOverview } from "./overview";
import { DeepDives } from "./deep-dives";
import { Benefits } from "./benefits";
import { Usps } from "./usps";
import { WhoItsFor } from "./who-its-for";
import { WhyChooseUs } from "./why-choose-us";
import { FAQ } from "./faq";
import { PAA } from "./paa";
import { Cta } from "./cta";

export function CapabilitiesPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <Problem />
      <div className="bg-aurora-crimson">
        <Solution />
      </div>
      <CapabilitiesOverview />
      <DeepDives />
      <div className="bg-aurora-emerald">
        <Benefits />
      </div>
      <Usps />
      <div className="bg-aurora-denim">
        <WhoItsFor />
      </div>
      <WhyChooseUs />
      <div className="bg-aurora-cyan">
        <FAQ />
      </div>
      <PAA />
      <Cta />
    </>
  );
}
